import React from 'react';
import SelectionListItem, {
	SelectionListItemScheme,
} from './SelectionListItem';
// @ts-ignore
import styles from './SelectionList.module.scss';

interface Props {
	data: SelectionListItemScheme[];
	onItemClick: (item: SelectionListItemScheme) => void;
	buttonLabel: string;
}

const SelectionList: React.FC<Props> = ({ data, onItemClick, buttonLabel }) => {
	return (
		<div className={styles.wrapper}>
			{data.map(item => (
				<React.Fragment key={item.id}>
					<SelectionListItem
						item={item}
						onClick={onItemClick}
						buttonLabel={buttonLabel}
					/>
				</React.Fragment>
			))}
		</div>
	);
};

export default SelectionList;
